import { isHistoricalViewport } from './predicates';
import { parseDuration } from './time';
export const viewportStartDate = (viewport, currentDate) => isHistoricalViewport(viewport)
    ? new Date(viewport.start)
    : new Date(((currentDate === null || currentDate === void 0 ? void 0 : currentDate.getTime()) || Date.now()) -
        parseDuration(viewport.duration));
export const viewportEndDate = (viewport, currentDate) => {
    return isHistoricalViewport(viewport)
        ? new Date(viewport.end)
        : currentDate || new Date(Date.now());
};
